import * as types from './types';

function crossPostingFilteredReducer(state, action) {
  switch (action.type) {
    case types.FETCH_POSTING:
      state.postingFiltered.loading = 'loading';
      state.postingFiltered.id = action.payload;
      state.postingFiltered.isPosting = true;
      state.table.params = { ...state.table.params, postingId: action.payload };
      state.table.paramsOther = { ...state.table.paramsOther, postingId: action.payload };
      state.table.paramsPhoneCall = { ...state.table.paramsPhoneCall, postingId: action.payload };
      state.table.paramsWhatsapp = { ...state.table.paramsWhatsapp, postingId: action.payload };
      state.table.paramsEmails = { ...state.table.paramsEmails, postingId: action.payload };

      return { ...state };
    case types.NO_POSTING:
      state.postingFiltered.loading = '';
      state.postingFiltered.id = undefined;
      state.postingFiltered.isPosting = false;
      state.table.params = { ...state.table.params, postingId: '' };
      state.table.paramsOther = { ...state.table.paramsOther, postingId: '' };
      state.table.paramsPhoneCall = { ...state.table.paramsPhoneCall, postingId: '' };
      state.table.paramsWhatsapp = { ...state.table.paramsWhatsapp, postingId: '' };
      state.table.paramsEmails = { ...state.table.paramsEmails, postingId: '' };
      return { ...state };
    default:
      return { ...state };
  }
}

export default crossPostingFilteredReducer;
